<template>
	<swiper :options="swiperOption" class="notice-swiper">
		<swiper-slide v-for="(item, index) in list" :key="index" class="swiper-item">
			<div class="roll-list">{{ item }}</div>
		</swiper-slide>
	</swiper>
</template>

<script>
export default {
	name: "NoticeSwiper",
	props: {
		list: {
			type: Array,
			default: () => [],
		},
		delay: {
			type: Number,
			default: 3000, // 每条公告切换时间
		},
		speed: {
			type: Number,
			default: 500, // 动画速度
		},
	},
	data() {
		return {
			swiperOption: {
				direction: "vertical",
				loop: true,
				autoplay: {
					delay: this.delay,
					disableOnInteraction: false,
				},
				speed: this.speed,
			},
		};
	},
};
</script>

<style scoped lang="scss">
.notice-swiper {
	height: 50px; // 每条公告高度
	overflow: hidden;
	margin: 0px 10px;

	.swiper-item {
		display: flex;
		align-items: center;
		height: 50px;

		.roll-list {
			font-size: 20px;
			color: #fff;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}
	}
}
</style>
